import { render, staticRenderFns } from "./PackageTotalTrendChart.vue?vue&type=template&id=363677d8&scoped=true"
import script from "./PackageTotalTrendChart.vue?vue&type=script&lang=js"
export * from "./PackageTotalTrendChart.vue?vue&type=script&lang=js"
import style0 from "./PackageTotalTrendChart.vue?vue&type=style&index=0&id=363677d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363677d8",
  null
  
)

export default component.exports